import showcaseCommentSuccess from './events/showcaseCommentSuccess'
import showcaseEditCommentSuccess from './events/showcaseEditCommentSuccess'
import showcaseReplySuccess from './events/showcaseReplySuccess'

const eventBus = { showcaseCommentSuccess, showcaseEditCommentSuccess, showcaseReplySuccess }
export default eventBus
